import { render, staticRenderFns } from "./CalendarDashboardModuleContent.vue?vue&type=template&id=4895d712&scoped=true"
import script from "./CalendarDashboardModuleContent.vue?vue&type=script&lang=js"
export * from "./CalendarDashboardModuleContent.vue?vue&type=script&lang=js"
import style0 from "./CalendarDashboardModuleContent.vue?vue&type=style&index=0&id=4895d712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895d712",
  null
  
)

export default component.exports